import Route from '@ember/routing/route';
import type Router from '@ember/routing/router';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type CurrentUser from 'donor-elf-web/services/current-user';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import SessionService from 'donor-elf-web/services/session';

export default class IntervarsityFirstImport extends Route {
  @service declare currentUser: CurrentUser;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: Router;
  @service declare session: SessionService;

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');

    const user = this.currentUser.load();

    // afterLoginRoute will be empty when the first import is done
    if (isEmpty(this.currentUser.afterLoginRoute)) {
      this.router.transitionTo('funds.fund', 'selected-fund');
    }
  }

  model() {
    this.navbarSettings.title = 'Importing Data';
  }
}
